import React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
    0%, 80%, 100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1.0);
    }
`;

interface IProps {
  color?: string;
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const Dot = styled.div<{ $color: string; $delay: string }>`
  width: 5px;
  height: 5px;
  background-color: ${(props) => props.$color};
  border-radius: 100%;
  display: inline-block;
  animation: ${bounce} 1.4s infinite ease-in-out both;
  animation-delay: ${(props) => props.$delay};
`;

const LoadingDots: React.FC<IProps> = ({ color = '#ffffff' }) => {
  return (
    <Wrapper>
      <Dot $color={color} $delay='-0.32s' />
      <Dot $color={color} $delay='-0.16s' />
      <Dot $color={color} $delay='0s' />
    </Wrapper>
  );
};

export default LoadingDots;
